import {useQuery} from "@tanstack/react-query";
import {fetchDELETE, fetchGET, fetchPOST, fetchPUT} from "./fetch";
import {useMyMutation} from "./mymutation";

const REACT_QUERY_ID_AMODELS = "amodels";
const BASE_URL = "/api/amodels";

const AmodelsQueryConfig = {
    staleTime: 0,
    cacheTime: 1000 * 60 * 5,
}

export const AMODELS_EMPTY = {
    sectorNummer: "",
    sector: "",
    stamNrClub: "",
    club: "",
    categorie: "",
    geboorteDatum: "",
    sex: "M",
    lidnummer: "",
    nationaliteit: "",
    opstellingDatum: "",
    naam: "",
    voornaam: "",
    rijksRegisterNummer: "",
    straat: "",
    nr: "",
    bus: "",
    land: "",
    postcode: "",
    gemeente: "",
    telefoon: "",
    email: "",
    straatBrief: "",
    nummerBrief: "",
    busBrief: "",
    landBrief: "",
    postcodeBrief: "",
    gemeenteBrief: "",
    optie: "",
    opmerking: "",
    verwerkt:''
};

export function useAmodels() {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_AMODELS],
        queryFn: async () => await fetchGET(BASE_URL),
        //onError: e => setError(e),
        ...AmodelsQueryConfig
    });
    return {...result, amodels: result.data};
}


export function useAmodel(id) {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_AMODELS, id],
        queryFn: async () => id ? await fetchGET(`${BASE_URL}/${id}`) : {},
        //onError: e => setError(e),
        ...AmodelsQueryConfig
    });
    return {...result, amodel: result.data};
}

export function useAmodelMutations() {
    async function createFunction(amodel) {
        if (!amodel) return;
        return await fetchPOST(BASE_URL, amodel, false);
    }

    async function editFunction(amodel) {
        if (!amodel) return;
        return await fetchPUT(`${BASE_URL}/${amodel.id}`, amodel);
    }

    async function editAddNewFiles(amodel) {
        if (!amodel) return;
        return await fetchPUT(`${BASE_URL}/${amodel.id}/files`, amodel.fileId);
    }

    async function deleteFunction(amodel) {
        return await fetchDELETE(`${BASE_URL}/${amodel.id}`)
    }

    return {
        createAmodel: useMyMutation(createFunction, REACT_QUERY_ID_AMODELS, amodel => `Amodel ${amodel.title} created`),
        editAmodel: useMyMutation(editFunction, REACT_QUERY_ID_AMODELS, amodel => `Amodel ${amodel.title} modified`),
        editAddNewFiles: useMyMutation(editAddNewFiles, REACT_QUERY_ID_AMODELS, amodel => `Amodel ${amodel.title} modified`),
        deleteAmodel: useMyMutation(deleteFunction, REACT_QUERY_ID_AMODELS, amodel => `Amodel ${amodel.title} deleted.`)
    };

}